import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";

export function HomeIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 21 21" htmlColor="#1C1B1F" {...props}>
      <path d="M3.784 16.559V9.187a1.5 1.5 0 0 1 .603-1.205L9.13 4.408q.395-.3.903-.301.507 0 .905.301l4.744 3.574a1.5 1.5 0 0 1 .602 1.205v7.372a1.2 1.2 0 0 1-.37.88 1.2 1.2 0 0 1-.88.37h-2.66a.73.73 0 0 1-.537-.217.73.73 0 0 1-.216-.537v-4.07a.73.73 0 0 0-.217-.537.73.73 0 0 0-.537-.216H9.201a.73.73 0 0 0-.537.216.73.73 0 0 0-.216.537v4.07a.73.73 0 0 1-.217.537.73.73 0 0 1-.537.217h-2.66q-.51 0-.88-.37a1.2 1.2 0 0 1-.37-.88" />
    </MuiSvgIcon>
  );
}
export default HomeIcon;
